<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row>
        <v-col sm="12" md="7" lg="7" class="mt-sm-20">
          <h2 class="">
            AI Ship Inspection Solution
          </h2>
          <strong class="pt-3"
            >Effortless Defect Detection and Maintenance Planning</strong
          >

          <div class="pt-2 divpara">
            Welcome to the future of ship inspections. Our AI-powered ship
            inspection solution simplifies the inspection process during the dry
            dock period, helping you detect defects and take corrective actions
            faster than ever before.
          </div>

          <div class="pt-3">
            <h3>How It Works:</h3>
          </div>
          <div class="texv pt-4">
            <div class="icon-container">
              <v-icon color="white" x-large> mdi mdi-pencil </v-icon>&nbsp;
              <span class="sicon"
                ><b>Record a 360-Degree Video</b> of your vessel’s structure and
                components.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large>mdi-cloud</v-icon>&nbsp;
              <span class="sicon"
                ><b>Upload the Video</b> to our platform, and let our AI do the
                rest.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large>mdi-cogs</v-icon>&nbsp;
              <span class="sicon"
                ><b>Receive an Automated Defect Report</b> with actionable
                insights, including dos and don’ts.</span
              >
            </div>
          </div>

          <div class="pt-3">
            <h3>Why Choose Us?</h3>
          </div>

          <div class="texv">
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-account-cog </v-icon>&nbsp;
              <span class="sicon"
                ><b>Advanced AI Technology:</b> Detects a wide range of defects
                with precision.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-map-marker-path </v-icon>&nbsp;
              <span class="sicon"
                ><b>Quick and Easy:</b> No complex setups—just upload a video
                and get a report.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-robot </v-icon>&nbsp;
              <span class="sicon"
                ><b>Cost-Effective:</b> Reduce inspection costs while improving
                accuracy.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-robot </v-icon>&nbsp;
              <span class="sicon"
                ><b>Cloud-Based Reports:</b> Access your inspection data from
                anywhere.</span
              >
            </div>
          </div>

          <div>
            <b>Book a Demo Today</b>
            <P>
              Experience how our AI-powered ship inspection can transform your
              maintenance workflow. Contact us to schedule a demo!
            </P>
          </div>
        </v-col>
        <v-col sm="12" md="5" lg="5"> <base-request /> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  name: "IconBackgrounds",
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "AI-Powered Ship Inspection";
  }
};
</script>

<style scoped>
.img {
  min-height: 200px;
}
.divpara {
  text-align: justify;
}
h1 {
  font-size: 30px;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}

.icon-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.v-icon {
  background-color: #1a237e; /* Background color for the icon */
  padding: 10px; /* Padding to make background bigger */
  border-radius: 50%; /* Makes the background circular */
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.sicon {
  margin-left: 10px;
  font-size: 18px;
}
</style>
